import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';

const buildStyle = (
  { backgroundColor, borderColor, depth, font, size },
  { readingDirection }
) => {
  return {
    caret: {
      base: {
        position: 'absolute'
      },
      position: {
        top: {
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: `6px solid ${borderColor.neutral.fill.surface}`,
          top: '100%',
          '&::before': {
            content: '""',
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            borderTop: `5px solid ${backgroundColor.neutral.fill.surface}`,
            position: 'absolute',
            bottom: 1,
            right: -5
          }
        },
        right: {
          borderTop: '6px solid transparent',
          borderBottom: '6px solid transparent',
          borderRight: `6px solid ${borderColor.neutral.fill.surface}`,
          right: '100%',
          '&::before': {
            content: '""',
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
            borderRight: `5px solid ${borderColor.neutral.fill.surface}`,
            position: 'absolute',
            left: 1,
            top: -5
          }
        },
        bottom: {
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderBottom: `6px solid ${borderColor.neutral.fill.surface}`,
          bottom: '100%',
          '&::before': {
            content: '""',
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            borderBottom: `5px solid ${borderColor.neutral.fill.surface}`,
            position: 'absolute',
            top: 1,
            right: -5
          }
        },
        left: {
          borderTop: '6px solid transparent',
          borderBottom: '6px solid transparent',
          borderLeft: `6px solid ${borderColor.neutral.fill.surface}`,
          left: '100%',
          '&::before': {
            content: '""',
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
            borderLeft: `5px solid ${borderColor.neutral.fill.surface}`,
            position: 'absolute',
            right: 1,
            top: -5
          }
        }
      }
    },
    triggerWrapper: {
      base: {
        cursor: 'pointer',
        // Fix to avoid pointer appearing on edges of disabled text links
        '& a': {
          display: 'block',
          width: '100%'
        }
      }
    },
    tooltipWrapper: {
      base: {
        backgroundColor: backgroundColor.neutral.fill.surface,
        border: `1px solid ${borderColor.neutral.fill.surface}`,
        borderRadius: size.border.radius.twoX,
        color: font.color.fill,
        fontFamily: font.base.family,
        fontSize: font.base.size.xxs,
        fontWeight: font.base.weight.regular,
        maxWidth: 282,
        padding: 8,
        pointerEvents: 'none',
        zIndex: depth.zIndex[400],
        ...readingDirection
      },
      position: {
        top: {
          marginBottom: 8
        },
        right: {
          marginLeft: 8
        },
        bottom: {
          marginTop: 8
        },
        left: {
          marginRight: 8
        }
      }
    }
  };
};

const useStyle = isRtl => {
  const {
    caret,
    triggerWrapper,
    tooltipWrapper
  } = useBuildStyleWithTheme(buildStyle, { isRtl });

  return {
    caret: caret.base,
    caretPosition: caret.position,
    triggerWrapper: triggerWrapper.base,
    tooltipWrapper: tooltipWrapper.base,
    tooltipPosition: tooltipWrapper.position
  };
};

export default useStyle;
